import _regeneratorRuntime from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Class, fetch2 } from '../utils';
var serviceUrl = "https://dawa.aws.dk";
export var Query = Class({
  options: null,
  initialize: function initialize(options) {
    this.options = Object.assign({}, options);
    if (typeof this.options.kommunekode !== 'undefined') this.options.kommunekode = this.options.kommunekode.toString(); //this.adresseQuery = new AdresseQuery(options);
    //this.vejQuery = new VejQuery(options);
  },
  query: function () {
    var _query = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var getOptions, vejStykker, veje, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, vejStykke, searchResult;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!this.queryCouldBeVejkode(this.options.query)) {
                _context.next = 28;
                break;
              }

              getOptions = {
                kode: this.options.query
              };
              if (typeof this.options.kommunekode !== 'undefined' && this.options.kommunekode !== "*") getOptions.kommunekode = this.options.kommunekode;
              _context.next = 5;
              return new VejStykkeGetter().get(getOptions);

            case 5:
              vejStykker = _context.sent;

              if (!(typeof vejStykker !== 'undefined')) {
                _context.next = 28;
                break;
              }

              veje = [];
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 11;

              for (_iterator = vejStykker[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                vejStykke = _step.value;
                veje.push({
                  type: "vej",
                  vejnavn: vejStykke.properties.navn,
                  postnummer: vejStykke.properties.postnumre[0].nr,
                  postdistrikt: vejStykke.properties.postnumre[0].navn
                });
              }

              _context.next = 19;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](11);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 19:
              _context.prev = 19;
              _context.prev = 20;

              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }

            case 22:
              _context.prev = 22;

              if (!_didIteratorError) {
                _context.next = 25;
                break;
              }

              throw _iteratorError;

            case 25:
              return _context.finish(22);

            case 26:
              return _context.finish(19);

            case 27:
              return _context.abrupt("return", veje);

            case 28:
              this.adresseQuery = new AdresseQuery(this.options);
              this.vejQuery = new VejQuery(this.options);
              _context.next = 32;
              return Promise.all([this.adresseQuery.query(), this.vejQuery.query()]);

            case 32:
              _context.next = 34;
              return this.buildSearchResult();

            case 34:
              searchResult = _context.sent;
              return _context.abrupt("return", searchResult);

            case 36:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[11, 15, 19, 27], [20,, 22, 26]]);
    }));

    function query() {
      return _query.apply(this, arguments);
    }

    return query;
  }(),
  queryCouldBeVejkode: function queryCouldBeVejkode(query) {
    if (query.length === 4) {
      var parseResult = parseInt(query);
      if (!isNaN(parseResult)) return true;
    }

    return false;
  },
  buildSearchResult: function () {
    var _buildSearchResult = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var adrCount, vejCount, vejnavnCount, limit, result, data;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              adrCount = this.adresseQuery.getAdresseCount();
              vejCount = this.vejQuery.getVejCount();
              vejnavnCount = this.vejQuery.getVejnavnCount();
              limit = this.options.limit;
              result = [];

              if (!(adrCount === 0)) {
                _context2.next = 9;
                break;
              }

              return _context2.abrupt("return", result);

            case 9:
              if (!(vejCount > 1)) {
                _context2.next = 18;
                break;
              }

              if (!(vejCount <= limit || vejnavnCount == 1)) {
                _context2.next = 14;
                break;
              }

              return _context2.abrupt("return", this.vejQuery.buildVejResult(limit));

            case 14:
              if (!(vejnavnCount > 0)) {
                _context2.next = 16;
                break;
              }

              return _context2.abrupt("return", this.vejQuery.buildVejnavnResult(limit));

            case 16:
              _context2.next = 33;
              break;

            case 18:
              result = this.adresseQuery.buildAdresseResult(limit);

              if (!this.options.showOneStreet) {
                _context2.next = 32;
                break;
              }

              if (!(vejCount > 0)) {
                _context2.next = 25;
                break;
              }

              //Vis den ene, der er fundet
              result = this.vejQuery.buildVejResult(limit).concat(result);
              return _context2.abrupt("return", result);

            case 25:
              _context2.next = 27;
              return new AdgangsAdresseGetter().get(result[0].id);

            case 27:
              data = _context2.sent;
              result = [{
                type: "vej",
                vejnavn: data.properties.vejstykke.navn,
                postnummer: data.properties.postnummer.nr,
                postdistrikt: data.properties.postnummer.navn,
                vejkode: data.properties.vejstykke.kode
              }].concat(result);
              return _context2.abrupt("return", result);

            case 30:
              _context2.next = 33;
              break;

            case 32:
              return _context2.abrupt("return", result);

            case 33:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function buildSearchResult() {
      return _buildSearchResult.apply(this, arguments);
    }

    return buildSearchResult;
  }(),
  buildSearchResult_org: function () {
    var _buildSearchResult_org = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3() {
      var adrCount, vejCount, vejnavnCount, limit, result, data;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              adrCount = this.adresseQuery.getAdresseCount();
              vejCount = this.vejQuery.getVejCount();
              vejnavnCount = this.vejQuery.getVejnavnCount();
              limit = this.options.limit;
              result = [];

              if (!(adrCount === 0)) {
                _context3.next = 9;
                break;
              }

              return _context3.abrupt("return", result);

            case 9:
              if (!(adrCount <= limit || vejCount <= 1)) {
                _context3.next = 27;
                break;
              }

              result = this.adresseQuery.buildAdresseResult(limit);

              if (!this.options.showOneStreet) {
                _context3.next = 24;
                break;
              }

              if (!(vejCount > 0)) {
                _context3.next = 17;
                break;
              }

              //Vis den ene, der er fundet
              result = this.vejQuery.buildVejResult(limit).concat(result);
              return _context3.abrupt("return", result);

            case 17:
              _context3.next = 19;
              return new AdgangsAdresseGetter().get(result[0].id);

            case 19:
              data = _context3.sent;
              result = [{
                type: "vej",
                vejnavn: data.properties.vejstykke.navn,
                postnummer: data.properties.postnummer.nr,
                postdistrikt: data.properties.postnummer.navn,
                vejkode: data.properties.vejstykke.kode
              }].concat(result);
              return _context3.abrupt("return", result);

            case 22:
              _context3.next = 25;
              break;

            case 24:
              return _context3.abrupt("return", result);

            case 25:
              _context3.next = 36;
              break;

            case 27:
              if (!(vejCount > 0 && (vejCount <= limit || vejnavnCount == 1))) {
                _context3.next = 31;
                break;
              }

              return _context3.abrupt("return", this.vejQuery.buildVejResult(limit));

            case 31:
              if (!(vejnavnCount > 0)) {
                _context3.next = 35;
                break;
              }

              return _context3.abrupt("return", this.vejQuery.buildVejnavnResult(limit));

            case 35:
              return _context3.abrupt("return", result);

            case 36:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function buildSearchResult_org() {
      return _buildSearchResult_org.apply(this, arguments);
    }

    return buildSearchResult_org;
  }(),
  CLASS_NAME: 'Septima.Search.Dawa.Query'
});
var AdresseQuery = Class({
  response: null,
  initialize: function initialize(options) {
    this.response = [];
    this.options = options;
  },
  query: function () {
    var _query2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4() {
      var callParameters, data, directResponse, data2, blankAppendixResponse, i, directAdr, j;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(this.options.query === "" && 1 === 2)) {
                _context4.next = 4;
                break;
              }

              return _context4.abrupt("return");

            case 4:
              callParameters = {
                q: this.options.query === "" ? "a" : this.options.query,
                type: "adgangsadresse",
                side: 1,
                per_side: this.options.limit + 1,
                noformat: 1
              };
              if (typeof this.options.kommunekode !== 'undefined' && this.options.kommunekode !== "*") callParameters.kommunekode = this.options.kommunekode;
              _context4.next = 8;
              return fetch2(serviceUrl + "/adgangsadresser/autocomplete", {
                data: callParameters
              });

            case 8:
              data = _context4.sent;
              directResponse = data;
              directResponse = this.sortAdresseResponse(directResponse);
              callParameters.q = callParameters.q + " ";
              _context4.next = 14;
              return fetch2(serviceUrl + "/adgangsadresser/autocomplete", {
                data: callParameters
              });

            case 14:
              data2 = _context4.sent;
              blankAppendixResponse = data2;

              if (blankAppendixResponse.length === directResponse.length) {
                this.response = directResponse;
              } else {
                for (i = directResponse.length - 1; i >= 0; i--) {
                  directAdr = directResponse[i];

                  for (j = 0; j < blankAppendixResponse.length; j++) {
                    if (blankAppendixResponse[j].adgangsadresse.id === directAdr.adgangsadresse.id) directResponse.splice(i, 1);
                  }
                }

                this.response = blankAppendixResponse.concat(directResponse);
              }

              return _context4.abrupt("return");

            case 18:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function query() {
      return _query2.apply(this, arguments);
    }

    return query;
  }(),
  getAdresseCount: function getAdresseCount() {
    return this.response.length;
  },
  buildAdresseResult: function buildAdresseResult(limit) {
    var result = [];

    for (var i = 0; i < this.response.length && result.length < limit; i++) {
      var adr = this.response[i];
      result.push({
        type: "adgangsadresseinfo",
        tekst: adr.tekst,
        id: adr.adgangsadresse.id
      });
    }

    return result;
  },
  sortAdresseResponse: function sortAdresseResponse(response) {
    //	    {
    //	        "id": "0a3f507c-8d5d-32b8-e044-0003ba298018",
    //	        "href": "https://dawa.aws.dk/adgangsadresser/0a3f507c-8d5d-32b8-e044-0003ba298018",
    //	        "vejnavn": "Sortsøvej",
    //	        "husnr": "6",
    //	        "supplerendebynavn": null,
    //	        "postnr": "2730",
    //	        "postnrnavn": "Herlev",
    //	        "stormodtagerpostnr": null,
    //	        "stormodtagerpostnrnavn": null
    //	    }
    var sorter = function sorter(r1, r2) {
      try {
        var h1 = parseInt(r1.adgangsadresse.husnr);
        var h2 = parseInt(r2.adgangsadresse.husnr);
        var p1 = parseInt(r1.adgangsadresse.postnr);
        var p2 = parseInt(r2.adgangsadresse.postnr);
        if (h1 === h2) return p1 - p2;else return h1 - h2;
      } catch (error) {
        return 0;
      }
    };

    return response.sort(sorter);
  },
  CLASS_NAME: 'Septima.Search.Dawa.AdresseQuery'
});
export var AdgangsAdresseGetter = Class({
  initialize: function initialize() {},
  get: function () {
    var _get = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee5(id) {
      var data;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return fetch2(serviceUrl + "/adgangsadresser/" + id, {
                data: {
                  srid: 25832,
                  format: "geojson",
                  struktur: "nestet"
                }
              });

            case 2:
              data = _context5.sent;
              return _context5.abrupt("return", data);

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    function get(_x) {
      return _get.apply(this, arguments);
    }

    return get;
  }(),
  sq: function () {
    var _sq = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee6(x, y) {
      var data;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return fetch2(serviceUrl + "/adgangsadresser/reverse", {
                data: {
                  srid: 25832,
                  format: "geojson",
                  struktur: "nestet",
                  x: x,
                  y: y
                }
              });

            case 2:
              data = _context6.sent;
              return _context6.abrupt("return", data);

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    function sq(_x2, _x3) {
      return _sq.apply(this, arguments);
    }

    return sq;
  }(),
  CLASS_NAME: 'Septima.Search.Dawa.AdgangsAdresseGetter'
});
export var VejQuery = Class({
  options: null,
  response: null,
  vejCount: null,
  initialize: function initialize(options) {
    this.options = options;
    this.response = [];
    this.vejCount = null;
  },
  query: function () {
    var _query3 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee7() {
      var callParameters, vejnavnePromise, vejstykkerPromise;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              callParameters = {
                q: "",
                side: 1,
                per_side: this.options.limit + 1,
                noformat: 1
              };
              if (this.options.query !== "") callParameters.q = this.options.query + "*";
              if (typeof this.options.kommunekode !== 'undefined' && this.options.kommunekode !== "*") callParameters.kommunekode = this.options.kommunekode;
              vejnavnePromise = fetch2(serviceUrl + "/vejnavne", {
                data: callParameters
              });
              vejstykkerPromise = fetch2(serviceUrl + "/vejstykker", {
                data: callParameters
              });
              _context7.next = 7;
              return Promise.all([vejnavnePromise, vejstykkerPromise]);

            case 7:
              _context7.next = 9;
              return vejnavnePromise;

            case 9:
              this.vejnavne = _context7.sent;
              _context7.next = 12;
              return vejstykkerPromise;

            case 12:
              this.vejstykker = _context7.sent;

            case 13:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    function query() {
      return _query3.apply(this, arguments);
    }

    return query;
  }(),
  getVejCount: function getVejCount() {
    if (this.vejCount === null) {
      var count = 0;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.vejstykker[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var vejstykke = _step2.value;
          count += vejstykke.postnumre.length;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.vejCount = count;
    }

    return this.vejCount;
  },
  buildVejResult: function buildVejResult(limit) {
    var result = [];

    for (var i = 0; i < this.vejstykker.length && result.length < limit; i++) {
      var vejstykke = this.vejstykker[i];

      for (var j = 0; j < vejstykke.postnumre.length && result.length < limit; j++) {
        var postnummer = vejstykke.postnumre[j];
        result.push({
          type: "vej",
          vejnavn: vejstykke.navn,
          postnummer: postnummer.nr,
          postdistrikt: postnummer.navn
        });
      }
    }

    return result;
  },
  getVejnavnCount: function getVejnavnCount() {
    return this.vejnavne.length;
  },
  buildVejnavnResult: function buildVejnavnResult(limit) {
    var result = [];

    for (var i = 0; i < this.vejnavne.length && result.length < limit; i++) {
      var vejNavn = this.vejnavne[i];
      var postNummer = void 0;

      if (vejNavn.navn.toLowerCase() === this.options.query.toLowerCase() && 1 == 2) {
        for (var j = 0; j < vejNavn.postnumre.length && result.length < limit; j++) {
          postNummer = vejNavn.postnumre[j];
          result.push({
            type: "vej",
            vejnavn: vejNavn.navn,
            postnummer: postNummer.nr,
            postdistrikt: postNummer.navn
          });
        }
      } else if (vejNavn.postnumre.length === 1) {
        postNummer = vejNavn.postnumre[0];
        result.push({
          type: "vej",
          vejnavn: vejNavn.navn,
          postnummer: postNummer.nr,
          postdistrikt: postNummer.navn
        });
      } else {
        result.push({
          type: "vejnavn",
          vejnavn: vejNavn.navn
        });
      }
    }

    return result;
  },
  CLASS_NAME: 'Septima.Search.Dawa.VejQuery'
});
export var VejStykkeGetter = Class({
  initialize: function initialize() {},
  get: function () {
    var _get2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee8(query) {
      var data;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              query.srid = 25832;
              query.format = "geojson";
              query.struktur = "nestet";
              _context8.next = 5;
              return fetch2(serviceUrl + "/vejstykker", {
                data: query
              });

            case 5:
              data = _context8.sent;
              return _context8.abrupt("return", data.features);

            case 7:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    function get(_x4) {
      return _get2.apply(this, arguments);
    }

    return get;
  }(),
  CLASS_NAME: 'Septima.Search.Dawa.VejStykkeGetter'
});